import { render, staticRenderFns } from "./GlChip.vue?vue&type=template&id=0bef17c1&"
import script from "./GlChip.vue?vue&type=script&lang=js&"
export * from "./GlChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports